import { CohortAgeScale } from '@/widgets/cohortRetention';
import { Select } from '@/shared/ui';

const ITEMS: { value: string; label: string }[] = [
  { value: `${CohortAgeScale.DAY}`, label: '1 day' },
  { value: `${CohortAgeScale.THREE_DAYS}`, label: '3 days' },
  { value: `${CohortAgeScale.WEEK}`, label: '7 days' },
  { value: `${CohortAgeScale.FOURTEEN_DAYS}`, label: '14 days' },
  { value: `${CohortAgeScale.THIRTY_DAYS}`, label: '30 days' },
];

interface Props {
  value: CohortAgeScale;
  onChange: (v: CohortAgeScale) => void;
}

export function CohortAgeSelect({ value, onChange }: Props) {
  const handleChange = (v: string) => {
    onChange(+v as CohortAgeScale);
  };

  return (
    <Select
      sx={{ width: 120 }}
      label="Cohort Age"
      options={ITEMS}
      value={`${value}`}
      onChange={handleChange}
    />
  );
}
